import React from 'react';
import { Widget } from 'shared/containers/portal_layout';
import numeral from 'numeral';
import { Fragments, Fragment } from 'shared/components/Fragments';

const numberToCurrency = amount => {
  if (!amount) return null;
  return numeral(amount).format('$0,0.00');
};

const fetchLevel = (data, category) => data.find(d => d.level === category) || {};

// This is a function (not a functional component), so it is valid to return an array
const section = ({ name, data }) => [
  <Subsection key="in" name={`${name} In Network`} dataKey="inNetwork" data={data} />,
  <Subsection key="out" name={`${name} Out of Network`} dataKey="outNetwork" data={data} />,
];

const Financials = ({ financials }) => (
  <Widget title="Financials" className="nopadding" span={12}>
    {financials ? (
      <table className="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th />
            <th>Individual</th>
            <th>Family</th>
          </tr>
        </thead>
        {section({ name: 'Deductible', data: financials.deductible })}
        {section({ name: 'Stop Loss', data: financials.stopLoss })}
      </table>
    ) : (
      <p>No financial data available</p>
    )}
  </Widget>
);

const Comments = ({ individual, family }) => {
  if ((individual && individual.length > 0) || (family && family.length > 0)) {
    return (
      <tr>
        <td>Comments: </td>
        <td>
          {individual && (
            <ul>
              {individual.map((c, idx) => (
                <li key={idx}>{c}</li>
              ))}
            </ul>
          )}
        </td>
        <td>
          {family && (
            <ul>
              {family.map((c, idx) => (
                <li key={idx}>{c}</li>
              ))}
            </ul>
          )}
        </td>
      </tr>
    );
  } else {
    return null;
  }
};

const Subsection = ({ name, data, dataKey }) => (
  <Fragments component="tbody">
    <Fragment>
      <tr>
        <td>
          <b>{name}</b>
        </td>
        <td> </td>
        <td> </td>
      </tr>
    </Fragment>
    {data.totals && (
      <Fragment>
        <tr>
          <td>Base Period: </td>
          <td>{numberToCurrency(fetchLevel(data.totals[dataKey], 'INDIVIDUAL').amount)}</td>
          <td>{numberToCurrency(fetchLevel(data.totals[dataKey], 'FAMILY').amount)}</td>
        </tr>
        <Comments
          individual={fetchLevel(data.totals[dataKey], 'INDIVIDUAL').comments}
          family={fetchLevel(data.totals[dataKey], 'FAMILY').comments}
        />
      </Fragment>
    )}
    {data.remainings && (
      <Fragment>
        <tr>
          <td>Remaining: </td>
          <td>{numberToCurrency(fetchLevel(data.remainings[dataKey], 'INDIVIDUAL').amount)}</td>
          <td>{numberToCurrency(fetchLevel(data.remainings[dataKey], 'FAMILY').amount)}</td>
        </tr>
        <Comments
          individual={fetchLevel(data.remainings[dataKey], 'INDIVIDUAL').comments}
          family={fetchLevel(data.remainings[dataKey], 'FAMILY').comments}
        />
      </Fragment>
    )}
  </Fragments>
);

export default Financials;
